import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from "react";
import { translate } from '@haldor/ui';
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import Moment from "moment";
import { getSchoolDetails, updateSchoolType } from "actions/schools";
import { getActiveSchool } from 'helpers/localstorage';
import SectionTitle from 'components/Presentation/SectionTitle';
import { DataList, Expandable } from 'UI';
import RowItem, { RowCell } from 'UI/Elements/List/RowItem';
import { Flex, Skeleton, Menu, Icon, TooltipMenu, Button, getActiveLanguage } from '@haldor/ui';
import { setActiveSchool, getMe } from 'actions/user';
import User from '_class/User';

var SchoolAdministration = /*#__PURE__*/function (_Component) {
  _inherits(SchoolAdministration, _Component);

  var _super = _createSuper(SchoolAdministration);

  function SchoolAdministration(props) {
    var _this;

    _classCallCheck(this, SchoolAdministration);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "changeSchoolType", function (school, schoolType) {
      _this.props.updateSchoolType(school.id, schoolType);
    });

    _defineProperty(_assertThisInitialized(_this), "renderSchoolRow", function (school) {
      var dropdownTrigger = /*#__PURE__*/React.createElement("div", {
        className: "dropdown--trigger"
      }, _this.props.translate(school.type), " ", /*#__PURE__*/React.createElement(Icon, {
        name: "Chevron"
      }));
      return /*#__PURE__*/React.createElement(RowItem, {
        key: school.id
      }, /*#__PURE__*/React.createElement(RowCell, {
        title: _this.props.translate('name')
      }, school.title), /*#__PURE__*/React.createElement(RowCell, {
        title: _this.props.translate('type')
      }, /*#__PURE__*/React.createElement(TooltipMenu, {
        trigger: dropdownTrigger
      }, _this.state.typeOfSchools.map(function (type) {
        if (type.type != school.type) {
          return /*#__PURE__*/React.createElement(TooltipMenu.Item, {
            key: 'type-' + school.id + "-" + type.id,
            onClick: function onClick() {
              return _this.changeSchoolType(school, type.type);
            }
          }, _this.props.translate(type.type));
        }
      }))));
    });

    Moment.locale(getActiveLanguage());
    _this.state = {
      school: [],
      schools: [],
      typeOfSchools: [{
        id: 1,
        type: "PRESCHOOL"
      }, {
        id: 2,
        type: "COMPULSORY_SCHOOL"
      }, {
        id: 3,
        type: "UPPER_SECONDARY_EDUCATION"
      }, {
        id: 4,
        type: "ADULT_EDUCATION"
      }]
    };
    return _this;
  }

  _createClass(SchoolAdministration, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var user = new User(this.props.currentUser);
      var activeSchool = getActiveSchool(this.props.currentUser.id);

      if (this.props.school == null) {
        return /*#__PURE__*/React.createElement("div", {
          className: "single-section"
        }, /*#__PURE__*/React.createElement(SectionTitle, null, /*#__PURE__*/React.createElement(Skeleton, null)), /*#__PURE__*/React.createElement(Flex, null, /*#__PURE__*/React.createElement("div", {
          style: {
            flex: 1
          }
        }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Skeleton, null)))));
      }

      var schools = [];
      this.props.currentUser.schools.forEach(function (school) {
        if (school.id == _this2.props.school.id) {
          schools.push(_this2.props.school);
        } else {
          schools.push(school);
        }
      });
      return /*#__PURE__*/React.createElement("div", {
        className: "single-section"
      }, /*#__PURE__*/React.createElement(DataList, {
        data: schools,
        renderRow: this.renderSchoolRow,
        emptyData: function emptyData() {
          return /*#__PURE__*/React.createElement("h3", {
            style: {
              textAlign: 'center'
            }
          }, _this2.props.translate('no-results'));
        }
      }));
    }
  }]);

  return SchoolAdministration;
}(Component);

_defineProperty(SchoolAdministration, "contextTypes", {
  router: PropTypes.object
});

function mapStateToProps(state, ownProps) {
  return {
    translate: translate(state.Languages.translations),
    tenant: state.user.tenant,
    currentUser: state.user.currentUser,
    school: state.School.active
  };
}

export default connect(mapStateToProps, {
  setActiveSchool: setActiveSchool,
  getSchoolDetails: getSchoolDetails,
  updateSchoolType: updateSchoolType
})(SchoolAdministration);